const loginErrorMessages = {
	invalidGrant: 'invalid_grant',
	invalidGrantLock: 'invalid_grant_lock',
	invalidGrantApprove: 'invalid_grant_approve',
	invalidOrganizationIdentifier: 'invalid_organization_identifier',
	organizationLocked: 'organization_locked',
};

export { loginErrorMessages };



// WEBPACK FOOTER //
// ./src/common/constants/loginErrorMessages.js